export default "__VITE_ASSET__03294e93__"